<template>
  <v-app>
  <v-data-table
    v-model="selected"
    :headers="headers"
    :items="desserts"
    :single-select="singleSelect"
    item-key="ID"
    show-select
    style="padding:25px">
    
    <template v-slot:top>
      <div>
          <div>
            <v-toolbar style="box-shadow:none !important">
              <v-toolbar-title><b>{{title}}</b></v-toolbar-title>
              <v-spacer></v-spacer>
              
              <v-spacer></v-spacer>
              <v-breadcrumbs>User / Server Role</v-breadcrumbs>
              <v-btn icon v-on:click="getData()">
                  <v-icon>mdi-refresh</v-icon>
                </v-btn>
            </v-toolbar>

            <div style="padding:0px 25px">
                <v-layout row>
                  <v-flex md8>
                      <v-btn rounded style="margin-top:15px" color="primary" large v-on:click="modalForm">
                          <v-icon dark style="margin-right:10px">mdi-plus</v-icon>
                          Add Data
                      </v-btn>
                  </v-flex>
                  <v-flex md4>
                      <v-col cols="12" sm="6" md="12">
                        <v-text-field
                          
                          v-model="val"
                           v-on:keyup.enter="getData()"
                          placeholder="Enter Your Keywords"
                          solo
                          append-icon="search"
                        ></v-text-field>
                      </v-col>
                  </v-flex>

                </v-layout>   
            </div>
        </div>
      </div>

      <v-dialog
        v-model="modal_form"
        max-width="500px"
      >
        <v-card>
          <v-card-title>
            Server Role
          </v-card-title>
          <v-card-text>
              <v-form
                ref="form"
                v-model="valid"
                lazy-validation
              >
                  <div style="padding:10px">
                      <label>
                          Server
                      </label>
                      <v-select 
                        item-text="SERVER_CODE"
                        item-value="SERVER_NAME"
                        v-model="server"
                        :items="list_server"
                        :rules="rules"
                        :disabled="disabled"
                        label="Choose Server"
                        v-bind:value="{ id: SERVER_CODE, text: SERVER_NAME }"
                        v-on:change="getUser(),nullUser()"
                        solo
                      ></v-select>

                      <label>
                          Approval 2
                      </label>

                      <v-select 
                        item-text="NAME"
                        item-value="USER_ID"
                        v-model="approval2"
                        :items="list_approval2"
                        :rules="rules"
                        label="Choose Approval 2"
                        v-bind:value="{ id: USER_ID, text: NAME }"
                        solo
                      ></v-select>

                      <label>
                          Cataloguer
                      </label>

                      <v-select 
                        item-text="NAME"
                        item-value="USER_ID"
                        v-model="cataloguer"
                        :items="list_cataloguer"
                        :rules="rules"
                        label="Choose Cataloguer"
                        v-bind:value="{ id: USER_ID, text: NAME }"
                        solo
                      ></v-select>
                  </div>
                        
                  <div align="right">
                      
                      <v-btn
                      color="primary"
                      text
                      @click="modal_form = false"
                      >
                        Close
                      </v-btn>

                      <v-btn
                      color="primary"
                      text
                      :loading="loading"
                      v-on:click="processForm"
                      >
                        Process
                      </v-btn>

                </div>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>

    </template>

    <template v-slot:item.status="{ item }">
        <v-chip color="success" v-if="item.STATUS=='Y'">Active</v-chip>
        <v-chip color="error" v-if="item.STATUS=='N'">Inactive</v-chip>
    </template>

    <template v-slot:item.action="{ item }">
      <v-icon
        medium
        class="mr-2"
        @click="edit(item)"
      >
        mdi-file-edit
      </v-icon>
 
      <v-icon
        medium
        class="mr-2"
        color="error"
        @click="changeStatus(item,'N')"
        v-if="item.STATUS=='Y'"
      >
         mdi-close-circle
      </v-icon>

      <v-icon
        medium
        class="mr-2"
        color="success"
        @click="changeStatus(item,'Y')"
        v-if="item.STATUS=='N'"
      >
         mdi-check-circle
      </v-icon>

    </template>
  </v-data-table>
  </v-app>
</template>


<script>
export default {
    methods: {
        getData(){
         var self = this;
          var val  = self.val; 
         
          var url  = self.base_url + "master/server_role";
          this.axios.post(url , {
              param:val,
          })
          .then(function (response) {
              self.desserts = response.data;
          });
      },
      modalForm(){
        var self = this;
        self.modal_form = true;
        
        self.getServer();
        self.getApproval2();
        self.getCataloguer();
        self.reset();
        self.disabled = false;
      },
      edit(item){
          var self = this;
          self.modal_form = true;
          self.getServer();
          self.id = item.ID;

          self.server = item.SERVER;
          self.approval2 = parseInt(item.APPROVAL2);
          self.cataloguer = parseInt(item.CATALOGUER);
          self.disabled = true;
      },
      reset () {
        this.id = "";
        this.$refs.form.reset();
      },
      processForm(){
        var self = this;
        if (self.$refs.form.validate()) {
          var url = "";
          self.loading = true;
          
          url  = self.base_url + "master/add_server_role";
          
          self.axios.post(url , {
              server : self.server,
              approval2 : self.approval2,
              cataloguer : self.cataloguer,
              id : self.id
          })
          .then(function (response) {
              if(response.data==true){
                self.modal_form = false;
                alert("Data succesfully saved");

              }else{
                alert(response.data)
              }
              self.getData();
              self.loading = false;
          });
        }
      },
      changeStatus(item,status){
        var self = this;
        var url  = self.base_url + "master/change_status";
         
        var text_confirm = 'Are you sure you want to Deactivated this data ?';
        
        if(status=='Y'){
          text_confirm = 'Are you sure you want to Activated this data ?';
        }

        this.$dialog.confirm({
          text: text_confirm,
          overlay:true,
          actions: {
              false: 'No',
              true: {
                color: 'red',
                text: 'Yes',
                handle: () => {
                     self.axios.post(url , {
                        id : item.ID,
                        status : status,
                        table : 'tx_approval_server',
                        field : 'ID'
                    })
                    .then(function (response) {
                        alert(response.data);
                        self.getData();
                    });                   
                }
              }
            }
        });
      },
      getServer(){
        var self = this;
        var url = self.base_url + "dropdown/server";
        self.axios.get(url).then(function (response) {
            self.list_server = response.data;
            self.getUser();
        })
      },
      getApproval2(){
        var self = this;
        var url = self.base_url + "dropdown/approval2";
        self.axios.get(url).then(function (response) {
            self.list_approval2 = response.data;
        })
      },
      getCataloguer(){
        var self = this;
        var url = self.base_url + "dropdown/cataloguer";
        self.axios.get(url).then(function (response) {
            self.list_cataloguer = response.data;
        })
      },
      nullUser(){
        this.user_id = "";
      }
    },
    mounted(){
        this.getData();
        this.getServer();
        this.getApproval2();
        this.getCataloguer();
    },
    data () { 
      return {
        valid: true,
        name : "Departement",
        title : "Data Approval 2 Role",
        dialog: false,
        loading:false,
        widgets: false,
        singleSelect: false,
        selected: [],
        showSelect:false,
        list_user:[],
        list_server:[],
        id:'',
        val:'',
        headers: [
          { text: 'Server', value: 'SERVER',width:150},
          { text: 'Approval 2', value: 'APPROVAL2_NAME',width:350},
          { text: 'Cataloguer', value: 'CATALOGUER_NAME',width:350},
          { text: 'Status', value: 'status', sortable: true,width:120},
          { text: 'Action', value: 'action', sortable: false,width:120},         
        ],
        desserts: [],
        modal_detail:false,
        detail:[],
        modal_form:false,
        rules : [
          v => !!v || 'Form is required',
          //v => (v && v.length <= 10) || 'This form must be less than 10 characters',
        ],

        //form..............................
        departement_id : "",
        user_id : "",
        list_cataloguer :"",
        list_approval2 : "",
        disabled : false,

        //storage.....................................
        storage_user_id : localStorage.getItem("user_id"),
        storage_username : localStorage.getItem("username"),
        storage_fullname : localStorage.getItem("fullname"),
        storage_company_id : localStorage.getItem("company_id"),
        storage_company_name : localStorage.getItem("company_name"),
        storage_role : localStorage.getItem("role"),
        storage_departement_id : localStorage.getItem("departement_id"),
        
      }
    },
  }
</script>
